import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

const OverallEvaluation = ({ evaluation, colors }) => {
    if (!evaluation) return null;

    const sections = [
        {
            title: 'Strengths Summary',
            content: evaluation.strengths_summary,
            icon: <StarIcon />,
            color: colors.greenAccent[400],
            bgColor: colors.greenAccent[900],
        },
        {
            title: 'Priority for Improvement',
            content: evaluation.improvement_priority,
            icon: <TrendingUpIcon />,
            color: colors.redAccent[400],
            bgColor: colors.redAccent[900],
        },
        {
            title: 'Strategic Advice',
            content: evaluation.strategic_advice,
            icon: <LightbulbIcon />,
            color: colors.blueAccent[400],
            bgColor: colors.blueAccent[900],
        },
    ];

    return (
        <Paper
            elevation={3}
            sx={{
                mt: 4,
                p: 3,
                backgroundColor: colors.primary[600],
                borderRadius: '12px',
            }}
        >
            <Typography variant="h5" fontWeight="bold" mb={3}>
                Overall Evaluation
            </Typography>

            <Box display="flex" flexDirection="column" gap={3}>
                {sections.map((section, index) => (
                    <Box key={index}>
                        {index > 0 && <Divider sx={{ mb: 3 }} />}
                        <Box
                            sx={{
                                p: 2,
                                borderRadius: '8px',
                                borderLeft: `4px solid ${section.color}`,
                                backgroundColor: `${section.bgColor}20`,
                            }}
                        >
                            <Box display="flex" alignItems="center" gap={1} mb={1}>
                                <Box sx={{ color: section.color }}>{section.icon}</Box>
                                <Typography variant="h6" fontWeight="bold" color={section.color}>
                                    {section.title}
                                </Typography>
                            </Box>
                            <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                                {section.content || 'No information available'}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Paper>
    );
};

export default OverallEvaluation;
